import styled from 'styled-components';

export const SlideContainerStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
`;

// work with height instead of width as everything will be rotated
export const SCHeadingsStyled = styled.div<{ts: number}>`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row;

  > .Scroller {
    flex: 1;
    position: relative;
    display: flex;
    flex-flow: row;
    overflow: hidden;

    > span {
      font-size: 25px;
      color: #aaaaaa;
      margin: 5px 8px 0px 8px;
      padding: 0;
      white-space: nowrap;
      cursor: pointer;
      transition: ${({ts}) => ts}s;
    }

    > span:hover {
      color: white;
    }
      
    > div {
      position: absolute;
      right: 50%;
      top: 50px;
      height: 6px;
      width: 0px;
      background-color: white;
      border-radius: 3px;
      transition: ${({ts}) => ts}s;
    }
  }

  > .Extra {
    height: 40px;
  }
    
`;

export const SCBodyStyled = styled.div<{ts: number}>`
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;

  > div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    transition: ${({ts}) => ts}s;
  }
`;